var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 10.2917V16.625H15.8333V15.0417H13.1258C12.5163 16.435 11.1229 17.4167 9.50001 17.4167C7.87709 17.4167 6.48376 16.435 5.87418 15.0417H3.16668V16.625H1.58334V10.2917H3.16668V11.875H5.88209C6.27793 10.9646 7.00626 10.2363 7.91668 9.83254V8.70837H6.33334V7.12504H12.6667V8.70837H11.0833V9.83254C11.9938 10.2363 12.7221 10.9646 13.1179 11.875H15.8333V10.2917H17.4167ZM13.4583 1.58337H5.54168C5.10626 1.58337 4.75001 1.93962 4.75001 2.37504C4.75001 2.81046 5.10626 3.16671 5.54168 3.16671H7.91668V3.95837H8.70834V6.33337H10.2917V3.95837H11.0833V3.16671H13.4583C13.8938 3.16671 14.25 2.81046 14.25 2.37504C14.25 1.93962 13.8938 1.58337 13.4583 1.58337Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValve);
export default __webpack_public_path__ + "static/media/Valve.b8f11b9acd4a7c3c575705315bea002c.svg";
export { ForwardRef as ReactComponent };